import { backend } from "src/api";

class DashboardApi {
  /** 전국 최신 대시보드의 CInfo 데이터를 하나의 캐시 응답으로 조회한다. */
  async getBriefing() {
    const response = await backend.get("/dashboard/briefing");
    return response.data;
  }

  /** 요약 카드를 열 때 요청하는 최신 주간 군구 순위다. */
  async getWeeklyGunguChart(metric) {
    const response = await backend.get("/dashboard/weekly-gungu-chart", {
      params: { metric },
    });
    return response.data;
  }

  async getStats(params = {}) {
    const response = await backend.get("/dashboard/stats", { params });
    return response.data;
  }

  async getStatDates(params = {}) {
    const response = await backend.get("/dashboard/stat-dates", { params });
    return response.data;
  }

}

export const dashboardApi = new DashboardApi();
